export default __webpack_public_path__ + "static/media/Mask Group Error 6.e485eaa6.png";